
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 6.941L8 2l5.5 4.941V14h-3.438v-2.823c0-.562-.217-1.1-.604-1.498A2.036 2.036 0 008 9.06c-.547 0-1.072.223-1.458.62a2.147 2.147 0 00-.604 1.498V14H2.5V6.941z","stroke":"#593289","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    